var d = Object.defineProperty;
var l = (t, e, o) => e in t ? d(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var h = (t, e, o) => l(t, typeof e != "symbol" ? e + "" : e, o);
import { CONFIG as g } from "@packages/config";
import { Injectable as w, Inject as p } from "@webmotors/ioc";
import "./main77.js";
import { LOGGER as f } from "./main78.js";
import { NoResponseError as q } from "./main213.js";
import { ServerError as c } from "./main214.js";
import { HttpMethod as x } from "./main81.js";
import { HTTP as P } from "./main82.js";
var y = Object.getOwnPropertyDescriptor, v = (t, e, o, s) => {
  for (var a = s > 1 ? void 0 : s ? y(e, o) : e, n = t.length - 1, r; n >= 0; n--)
    (r = t[n]) && (a = r(a) || a);
  return a;
}, u = (t, e) => (o, s) => e(o, s, t);
let m = class {
  constructor(t, e) {
    h(this, "logger");
    this.config = t, this.loggerFactory = e, this.logger = this.loggerFactory.create("Http");
  }
  async isPerimeterexError(t) {
    if (!t || typeof t.status != "number")
      return !1;
    const e = t;
    if (e.status !== 403)
      return !1;
    const o = [...e.headers.entries()].some(([s]) => s.toLowerCase().includes("perimeterx") || s.toLowerCase().startsWith("px-"));
    try {
      const s = e.headers.get("content-type");
      if (s != null && s.includes("application/json")) {
        const a = await e.clone().json(), n = typeof a == "object" && a !== null && "appId" in a && "uuid" in a;
        return o || n;
      }
    } catch (s) {
      this.logger.warn(
        "[isPerimeterexError] Erro ao analisar corpo da resposta:",
        s
      );
    }
    return o;
  }
  async request(t, e) {
    const o = new Headers(e == null ? void 0 : e.headers), s = new URLSearchParams(
      e == null ? void 0 : e.params
    ).toString(), a = `${t}?${decodeURIComponent(s)}`, n = {
      method: (e == null ? void 0 : e.method) ?? x.GET,
      headers: this.config.disabledHeaders ? {} : o,
      mode: "no-cors",
      ...e
    };
    this.logger.info("[request] sending request: ", a), this.logger.info("[request] request options: ", n);
    try {
      const r = await fetch(a, n);
      if (this.logger.info("[request] response status text: ", r.statusText), this.logger.info("[request] response status code: ", r.status), this.logger.info("[request] response: ", r), await this.isPerimeterexError(r))
        throw this.logger.error("[request] PerimeterX detected. Access denied."), r;
      if (!r.ok) {
        const i = await r.text();
        throw this.logger.error("[request] something went wrong", i), new c(i);
      }
      return r.text();
    } catch (r) {
      throw this.logger.error("[request] something went wrong", r), r instanceof c || r != null && r.response ? r : new q("No response received");
    }
  }
};
m = v([
  w(P),
  u(0, p(g)),
  u(1, p(f))
], m);
export {
  m as FetchService
};
